export var Color;
(function (Color) {
    Color["WHITE"] = "white";
    Color["BLACK"] = "black";
    Color["RED"] = "red";
})(Color || (Color = {}));
export var GameMode;
(function (GameMode) {
    GameMode["PROFESSIONAL"] = "professional";
    GameMode["FREESTYLE"] = "freestyle";
})(GameMode || (GameMode = {}));
export var Difficulty;
(function (Difficulty) {
    Difficulty["BEGINNER"] = "beginner";
    Difficulty["EXPERT"] = "expert";
})(Difficulty || (Difficulty = {}));
export var Collision;
(function (Collision) {
    Collision["COLLISION_LINE"] = "collision line";
    Collision["COLLISION_DISK"] = "collision disk";
    Collision["COLLISION_POCKET"] = "collision pocket";
})(Collision || (Collision = {}));
export var Lines;
(function (Lines) {
    Lines["LINE_N"] = "N";
    Lines["LINE_E"] = "E";
    Lines["LINE_S"] = "S";
    Lines["LINE_W"] = "W";
})(Lines || (Lines = {}));
export var Fault;
(function (Fault) {
    Fault["STRIKER_POCKETED"] = "striker pocketed";
    Fault["ADVERSARY_PUCK_POCKETED"] = "adversary puck pocketed";
    Fault["NO_PUCK_POCKETED"] = "no puck pocketed";
    Fault["QUEEN_NOT_COVERED"] = "queen not covered";
    Fault["LAST_PUCK_POCKETED"] = "last puck pocketed";
    Fault["LAST_ADVERSARY_PUCK_POCKETED"] = "last adversary puck pocketed";
})(Fault || (Fault = {}));
export var Errors;
(function (Errors) {
    Errors["ERROR_1"] = "Error 1";
    Errors["ERROR_2"] = "Error 2";
})(Errors || (Errors = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL1R5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXNEQSxNQUFNLENBQU4sSUFBWSxLQUlYO0FBSkQsV0FBWSxLQUFLO0lBQ2Isd0JBQWUsQ0FBQTtJQUNmLHdCQUFlLENBQUE7SUFDZixvQkFBVyxDQUFBO0FBQ2YsQ0FBQyxFQUpXLEtBQUssS0FBTCxLQUFLLFFBSWhCO0FBT0QsTUFBTSxDQUFOLElBQVksUUFHWDtBQUhELFdBQVksUUFBUTtJQUNoQix5Q0FBNkIsQ0FBQTtJQUM3QixtQ0FBdUIsQ0FBQTtBQUMzQixDQUFDLEVBSFcsUUFBUSxLQUFSLFFBQVEsUUFHbkI7QUFFRCxNQUFNLENBQU4sSUFBWSxVQUdYO0FBSEQsV0FBWSxVQUFVO0lBQ2xCLG1DQUFxQixDQUFBO0lBQ3JCLCtCQUFpQixDQUFBO0FBQ3JCLENBQUMsRUFIVyxVQUFVLEtBQVYsVUFBVSxRQUdyQjtBQUVELE1BQU0sQ0FBTixJQUFZLFNBSVg7QUFKRCxXQUFZLFNBQVM7SUFDakIsOENBQWlDLENBQUE7SUFDakMsOENBQWlDLENBQUE7SUFDakMsa0RBQXFDLENBQUE7QUFDekMsQ0FBQyxFQUpXLFNBQVMsS0FBVCxTQUFTLFFBSXBCO0FBRUQsTUFBTSxDQUFOLElBQVksS0FLWDtBQUxELFdBQVksS0FBSztJQUNiLHFCQUFZLENBQUE7SUFDWixxQkFBWSxDQUFBO0lBQ1oscUJBQVksQ0FBQTtJQUNaLHFCQUFZLENBQUE7QUFDaEIsQ0FBQyxFQUxXLEtBQUssS0FBTCxLQUFLLFFBS2hCO0FBRUQsTUFBTSxDQUFOLElBQVksS0FPWDtBQVBELFdBQVksS0FBSztJQUNiLDhDQUFxQyxDQUFBO0lBQ3JDLDREQUFtRCxDQUFBO0lBQ25ELDhDQUFxQyxDQUFBO0lBQ3JDLGdEQUF1QyxDQUFBO0lBQ3ZDLGtEQUF5QyxDQUFBO0lBQ3pDLHNFQUE2RCxDQUFBO0FBQ2pFLENBQUMsRUFQVyxLQUFLLEtBQUwsS0FBSyxRQU9oQjtBQUVELE1BQU0sQ0FBTixJQUFZLE1BR1g7QUFIRCxXQUFZLE1BQU07SUFDZCw2QkFBbUIsQ0FBQTtJQUNuQiw2QkFBbUIsQ0FBQTtBQUN2QixDQUFDLEVBSFcsTUFBTSxLQUFOLE1BQU0sUUFHakIifQ==